module.exports = __webpack_public_path__ + "media/images/floor_plan/table-194c704fdf590ea8126966ecf7eba529.svg";